<template>
  <div class="report-page">
    <div class="filter-card">
      <div class="fc-row fc-row-primary">
        <div class="field">
          <label class="field-lbl">ช่วงวันที่</label>
          <date-picker
            v-model="dateRange"
            type="date"
            range
            format="DD MMM YY"
            :shortcuts="dateRangeShortcuts"
            :disabled-date="notAfterToday"
            placeholder="เลือกวันที่ต้องการค้นหา"
            input-class="form-control form-control-sm field-input-native"
          ></date-picker>
        </div>

        <div class="field">
          <label class="field-lbl">แพทย์</label>
          <b-form-select
            v-model="doctorId"
            :options="getDoctorList"
            value-field="uid"
            text-field="fullName"
            size="sm"
            class="field-input-native"
          >
            <template v-slot:first>
              <b-form-select-option :value="null">
                แพทย์ทั้งหมด
              </b-form-select-option>
            </template>
          </b-form-select>
        </div>

        <b-button
          variant="primary"
          class="btn-primary-lg"
          @click="fetchLabReport"
        >
          แสดงข้อมูล
        </b-button>
      </div>
    </div>

    <div class="toolbar">
      <span></span>
      <div class="toolbar-right">
        <b-dropdown size="sm" variant="outline-success" right>
          <template #button-content>
            <i class="fas fa-download"></i>
          </template>
          <b-dropdown-item @click="excelExport('BranchLabReport')">
            <i class="fas fa-file-excel mr-2"></i>Excel
          </b-dropdown-item>
          <b-dropdown-item @click="pdfExport('BranchLabReport')">
            <i class="fas fa-file-pdf mr-2"></i>PDF
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-table
      id="BranchLabReport"
      ref="BranchLabReport"
      class="report-table"
      small
      sort-icon-left
      hover
      head-variant="light"
      :items="fileteredLabExpenseList"
      :fields="fields"
      sort-by="creationDt"
      v-model="visibleRows"
      :sort-desc="true"
      :responsive="true"
      show-empty
      sticky-header="calc(100vh - 210px)"
      @row-clicked="onRowClicked"
    >
      <template #cell(index)="row">{{ row.index + 1 }}.</template>

      <template #custom-foot>
        <b-tr variant="secondary" class="text-bold text-right">
          <td class="text-left">รวม</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

          <td>{{ sum("dfAmount") }}</td>
          <td>{{ sum("cfAmount") }}</td>
          <td>{{ sum("price") }}</td>
        </b-tr>
      </template>
      <template #empty="">
        <p class="text-center text-muted my-2">ไม่มีข้อมูลให้แสดง</p>
      </template>
      <template #cell(price)="row">
        <b-tooltip
          :target="'row-' + row.index"
          triggers="manual"
          placement="left"
          customClass="custom-tooltip"
          @shown="onTooltipShown"
          @hidden="onTooltipHidden"
        >
          <LabImageGallery
            v-if="isContainImage"
            cardClass="mb-0"
            photoSize="xs"
            imgStyle="min-width: 100px; height: auto; object-fit: contain"
            category="Invoice"
          />
          <p v-else class="p-3 mb-0">ไม่มีรูป</p>
        </b-tooltip>
        <span :id="'row-' + row.index">{{ row.value }}</span>
      </template>
      <template v-if="hasSubscribed" #table-caption>Click เพื่อดูรูป</template>
    </b-table>

    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { eventBus } from "@/main";

import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import moment from "moment";
import LabImageGallery from "@/components/card/Gallery";
import { exportTableToExcel, exportReportToPdf } from "@/utils/reportExport";

export default {
  name: "BranchLabReport",
  components: {
    Dialog,
    Loading,
    LabImageGallery,
  },
  data() {
    return {
      isLoading: false,
      dateRange: [],
      doctorId: null,

      fields: [
        {
          key: "creationDt",
          label: "วันที่สร้าง",
          sortable: true,
          class: "narrow-spacing",
          formatter: "formatDate",
        },
        {
          key: "dfDate",
          label: "วันที่คำนวน DF",
          sortable: true,
          class: "narrow-spacing",
          formatter: "formatDate",
        },
        {
          key: "recDate",
          label: "วันที่รับงาน",
          sortable: true,
          class: "narrow-spacing",
          formatter: "formatDate",
        },

        {
          key: "invoiceNo",
          label: "เลขที่ invoice",
          class: "narrow-spacing",
        },
        {
          key: "mLab",
          label: "งานแลป",
          class: "narrow-spacing",
          formatter(i) {
            return i?.nameTh || "";
          },
        },

        {
          key: "mCompanyLab",
          label: "ชื่อบริษัท",
          class: "narrow-spacing",
          formatter(i) {
            return i?.nameTh || "";
          },
        },
        {
          key: "patient",
          label: "ชื่อคนไข้",
          class: "narrow-spacing",
          formatter(i) {
            return `${i.firstNameTh} ${i.lastNameTh}`;
          },
        },
        {
          key: "doctor",
          label: "ชื่อแพทย์",
          class: "narrow-spacing",
          formatter(i) {
            return i.fullName;
          },
        },

        {
          key: "dfAmount",
          label: "หักแพทย์",
          class: "narrow-spacing text-right",
        },
        {
          key: "cfAmount",
          label: "หักคลินิก",
          class: "narrow-spacing text-right",
        },

        {
          key: "price",
          label: "รวม(บาท)",
          class: "narrow-spacing text-right",
        },
      ],
      visibleRows: [],
      loadingTime: 0,
      reportList: [],
      tooltipOpen: false,
      mediaFiles: [],
    };
  },
  created() {
    this.init();
    document.addEventListener("click", this.handleClickOutside);
  },
  computed: {
    ...mapGetters({
      getReportDateRange: "moduleReport/getReportDateRange",
      getDoctorList: "moduleUser/getDoctorList",
      dateRangeShortcuts: "moduleMaster/getDateRangeShortcuts",
      getLabExpenseList: "moduleLab/getLabExpenseList",
      hasSubscribed: "moduleBranch/hasSubscribed",
      branchInfo: "moduleBranch/getBranchInfo",
      clinicInfo: "moduleBranch/getClinicInfo",
    }),
    selectedDoctorName() {
      if (this.doctorId === null) return "";
      const doctor = this.getDoctorList.find(d => d.uid === this.doctorId);
      return doctor ? doctor.fullName : "";
    },
    fileteredLabExpenseList() {
      if (this.doctorId === null) return this.reportList;
      return this.reportList.filter(i => i.uid === this.doctorId);
    },
    dateFrom() {
      return this.dateRange[0]
        ? moment(this.dateRange[0]).format("DD/MM/YYYY")
        : "";
    },
    dateTo() {
      return this.dateRange[1]
        ? moment(this.dateRange[1]).format("DD/MM/YYYY")
        : "";
    },
    today() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      return today;
    },
    isContainImage() {
      return this.mediaFiles.length > 0;
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      fetchLabExpenseList: "moduleLab/fetchLabExpenseList",
      fecthMediaFiles: "moduleMediaFile/fecthMediaFiles",
    }),
    init() {},
    moment() {
      return moment();
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY");
      } else {
        return "";
      }
    },
    formatTime(date) {
      if (date) {
        return moment(date).locale("th").format("HH:mm");
      } else {
        return "";
      }
    },

    // showDialogToast(variant, textDetail) {
    //   this.$refs.Dialog.showToast(variant, textDetail);
    // },
    sum(key) {
      let splitStr = key.split(".");
      return this.visibleRows.reduce((accum, item) => {
        let data;
        if (splitStr.length > 1) {
          if (
            item[splitStr[0]] &&
            item[splitStr[0]][splitStr[1]] &&
            item[splitStr[0]][splitStr[1]][splitStr[2]]
          ) {
            data = item[splitStr[0]][splitStr[1]][splitStr[2]];
          } else {
            data = 0;
          }
        } else {
          data = item[key];
        }
        if (typeof data != "number") return null;
        return Math.round((accum + data) * 20) / 20;
      }, 0);
    },
    async fetchLabReport() {
      this.isLoading = true;
      await this.fetchLabExpenseList({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        event: {
          fromCreationDate: this.formatStartDate(this.dateRange[0]) || null,
          toCreationDate: this.formatEndDate(this.dateRange[1]) || null,
        },
      })
        .then(res => {
          this.reportList = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    notAfterToday(date) {
      return date > new Date(new Date().setHours(0, 0, 0, 0));
    },
    excelExport(id) {
      exportTableToExcel({
        tableId: id,
        reportTitle: "รายงานค่าใช้จ่ายแลป (สาขา)",
        reportNameEn: "LabCost",
        dateFrom: this.dateRange[0],
        dateTo: this.dateRange[1],
        doctorName: this.selectedDoctorName,
        branchName: this.branchInfo && this.branchInfo.name,
        clinicName: this.clinicInfo && this.clinicInfo.name,
      });
    },
    pdfExport(id) {
      exportReportToPdf({
        tableId: id,
        reportTitle: "รายงานค่าใช้จ่ายแลป (สาขา)",
        reportNameEn: "LabCost",
        dateFrom: this.dateRange[0],
        dateTo: this.dateRange[1],
        doctorName: this.selectedDoctorName,
        branchName: this.branchInfo && this.branchInfo.name,
        clinicName: this.clinicInfo && this.clinicInfo.name,
      });
    },
    formatStartDate(date) {
      return date ? moment(date).startOf("day").format() : null;
    },
    formatStartDateUtc(date) {
      return date ? moment(date).startOf("day").utc(true).format() : null;
    },
    formatEndDate(date) {
      return date ? moment(date).endOf("day").format() : null;
    },
    formatEndDateUtc(date) {
      return date ? moment(date).endOf("day").utc(true).format() : null;
    },
    async onRowClicked(item, index, event) {
      if (this.hasSubscribed) {
        const data = await this.fecthMediaFiles({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          params: { labId: item.id, limit: 100 },
        });
        this.mediaFiles = data;
        await this.$nextTick();

        this.$root.$emit("bv::show::tooltip", "row-" + index);
        return false;
      }
    },
    handleClickOutside(event) {
      if (this.tooltipOpen) {
        const clickedInsideTooltip =
          event.target.closest(".b-tooltip") ||
          event.target.closest('[id^="row-"]');
        if (!clickedInsideTooltip) {
          this.$root.$emit("bv::hide::tooltip");
        }
      }
    },
    onTooltipShown() {
      this.tooltipOpen = true;
    },
    onTooltipHidden() {
      this.tooltipOpen = false;
    },
  },

  mounted() {
    if (this.getReportDateRange[0] && this.getReportDateRange[1]) {
      this.dateRange = this.getReportDateRange;
    } else {
      this.dateRange = [this.today, this.today];
    }
  },
  updated() {},
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style>
.sr-only {
  display: none;
}
.custom-tooltip .tooltip-inner {
  max-width: 300px; /* Adjust as needed */
  padding: 0px;
}
</style>
